import apis from "../../../apis/api.actions";
import { parseQueryParams } from "../../../utils/formValidate";

export const getAttachment = (key) =>
apis.getDatas(`/attachment${parseQueryParams(key)}`).then((res) => res);
export const deleteAttachment = (data) =>
apis.deleteData(`/attachment/delete-attachment/`, {data}).then((res) => res);


